module.exports = __webpack_public_path__ + "img/pedestal.471b8c8e.png";